module.exports = __webpack_public_path__ + "static/media/relatorio-estado-vazio.0d8c59b3.gif";